import { render } from "./Sizes.vue?vue&type=template&id=3e0a9326"
import script from "./Sizes.vue?vue&type=script&lang=ts"
export * from "./Sizes.vue?vue&type=script&lang=ts"
script.render = render

export default script